module.exports = __webpack_public_path__ + "img/wallet_pc_08.59ba3597.png";